import React from "react";
import "./about.css";

const AboutUs = () => {
  return (
    <div className="footer-about-container">
      <header className="footer-about-header">
        <h1>About Us</h1>
        <p>E-Techno Educational and Research Society</p>
      </header>

      <section className="footer-about-section">
        <h2>Who We Are</h2>
        <p>
          E-Techno Educational and Research Society is a non-profit organization dedicated to promoting education, research, and innovation for societal development.
        </p>

        <h2>Our Mission</h2>
        <p>
          To empower communities through access to quality education, support for research, and sustainable initiatives that drive progress.
        </p>

        <h2>Our Vision</h2>
        <p>
          A world where education and research bridge the gap between potential and opportunity, fostering equality and innovation.
        </p>

        <h2>Core Values</h2>
        <p>
          We uphold values of inclusivity, integrity, innovation, sustainability, and transparency in all our operations.
        </p>

        <h2>Educational Initiatives</h2>
        <p>
          We provide scholarships, digital learning tools, and collaborate with schools to enhance learning opportunities for underserved communities.
        </p>

        <h2>Research Support</h2>
        <p>
          Our organization funds and promotes research projects addressing critical societal challenges like health, technology, and sustainability.
        </p>

        <h2>Skill Development</h2>
        <p>
          We organize training programs and workshops that equip individuals with skills to improve employability and entrepreneurial success.
        </p>

        <h2>Community Empowerment</h2>
        <p>
          Our projects focus on uplifting marginalized groups through awareness, education, and resource allocation.
        </p>

        <h2>Sustainable Solutions</h2>
        <p>
          E-Techno prioritizes environmentally sustainable practices in all programs, contributing to long-term societal benefits.
        </p>

        <h2>Donation Impact</h2>
        <p>
          Your contributions enable us to reach more communities, fund impactful projects, and provide essential resources where they are needed most.
        </p>

        <h2>Success Stories</h2>
        <p>
          From helping students achieve their academic dreams to funding innovative research, your donations have transformed countless lives.
        </p>

        <h2>Transparency</h2>
        <p>
          We ensure every donation is utilized effectively and provide regular reports on our activities and financial audits.
        </p>

        <h2>Global Recognition</h2>
        <p>
          Our initiatives have been acknowledged by esteemed organizations, further affirming the significance of our work.
        </p>

        <h2>How to Support Us</h2>
        <p>
          You can contribute by donating, volunteering, or partnering with us to amplify our impact.
        </p>
      </section>

      <footer className="footer-about-footer">
        <p>&copy; 2024 E-Techno Educational and Research Society. All rights reserved.</p>
        <p>Thank you for believing in our mission and supporting us in creating a brighter, more equitable future!</p>
      </footer>
    </div>
  );
};

export default AboutUs;
